<div class="clear"></div>
<a id="gallery"></a>

<h3>
  <strong>{{ title }} Gallery</strong>
</h3>
<div class="rows">
  @if (gallery.length === 0) {
    <p class="ib-preview-empty">No gallery images</p>
  } @else {
    <nz-image-group>
      <div class="masonry-grid" #masonryGrid>
        @for (img of gallery; track img; let i = $index) {
          <div [class]="tileClass(i)">
            <div>
              <a href="#" (click)="$event.preventDefault()">
                <img nz-image [nzSrc]="img" [src]="img" [alt]="title" />
              </a>
            </div>
          </div>
        }
        <div class="grid-sizer"></div>
      </div>
    </nz-image-group>
  }
</div>
